/*
import React from 'react'
import Helmet from 'react-helmet'

const ProtectionsCoveragesEn = () => (
  <div className="page protections_coverages">
  <Helmet
            title={`Coverturas y protecciones de Budget Nicaragua - Encuentra un alquiler de autos cerca de ti`}
            meta={[
              {
                name: 'description',
                content:
                  'Preguntas frecuentes sobre el alquiler de autos.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'es',
                href:
                  './en/protections-coverages',
              },
            ]}
          />

  <div className="image"></div>
    <h1>Protecciones y Coberturas</h1>
    <div>
      <div>  
        <ul>
          <li>
          <h2>C1 (SLI)</h2>
          <h3>U$12.99 diarios</h3>
          <p>
          Cobertura de Responsabilidad Civil por daños a terceros (OBLIGATORIA). <br/>
          Cobertura máxima, US$15,000. Deducible: 20%. Válida sólo en Nicaragua.<br/>
          </p>
          </li>
          <li>
          <h2>C2 (CDW + SLI)</h2>
          <h3>US$22.99 diarios</h3>
          <p>
          Exime parcialmente en caso de daños por colisión o robo total de vehículo. El cliente paga un deducible de:<br/>
          * US$1,000 en caso de daños por colisión<br/>
          * 20% en caso de robo total del vehículo<br/>
          Cobertura de Responsabilidad Civil por daños a terceros. Cobertura máxima: US$15,000. <br/>
          Deducible: 20%. Válida sólo en Nicaragua. <br/>
          </p>
          </li>
          <li>
          <h2>C3 (CDW + CLP + SLI)</h2>
          <h3>US$32.99 diarios</h3>
          <p>
          Exime totalmente en caso de daños por colisión y 80% en caso de robo total del vehículo.<br/>
          Cubre daños a llantas y daños en todos los vidrios del vehículo. No cubre robo.<br/>
          Cobertura de Responsabilidad Civil a terceros. Cobertura máxima: US$15,000. Deducible: 20%. <br/>
          Válida sólo en Nicaragua.<br/>
          </p>
          </li>
          <li>
          <h2>C4 (CDW + CLP + SLI + CDP + PIA + CAC + ACD)</h2>
          <h3>US$52.99 diarios</h3>
          <p>
          Exime totalmente en caso de daños por colisión y 80% en caso de robo total del vehículo.<br/>
          Cobertura de Responsabilidad Civil a terceros. Cobertura máxima: US$15,000. Deducible: 20%.<br/>
          Cubre daños a llantas y daños en todos los vidrios del vehículo.<br/>
          Adicionalmente, esta cobertura protege al cliente en caso de rayones, raspaduras, abolladuras, daños a: llavines, antenas, manecillas, espejos laterales, stops y otros daños a la carrocería del vehículo.<br/>
          Cubre robos parciales y daños en el interior del vehículo. Por esta cobertura la empresa asumirá un máximo de US$500.00. Si el monto del daño excede este valor el cliente pagará el excedente.<br/>
          Incluye Protección Individual por accidente a los pasajeros del vehículo de Budget. Reembolso de gastos médicos hasta por un monto de US5,000 por el total de pasajeros del vehículo, siempre que no excedan la capacidad de éste.<br/>
          Cobertura de Asistencia en Carretera en caso de dificultad o emergencia las 24 horas.<br/>
          Protege fuera del territorio nacional y asonadas en Nicaragua.<br/>
          </p>
          </li>
          <li>
          <h2>C5 (CDW + CLP + SLI + CDP + PIA)</h2>
          <h3>US$39.99 diarios</h3>
          <p>
          Exime totalmente en caso de daños por colisión y 80% caso de robo total del vehículo.<br/>
          Cobertura de Responsabilidad Civil a terceros. Cobertura máxima: US$15000. Deducible: 20%.<br/>
          Cubre daños a llantas y daños en todos los vidrios del vehículo.<br/>
          Adicionalmente, protege al cliente en caso de rayones, raspaduras, abolladuras, daños a: llavines, antenas, vidrios laterales y traseros, manecillas, espejos laterales, stops y otros daños a la carrocería del vehículo.<br/>
          Por esta cobertura la empresa asumirá un máximo de US$500.00. Si el monto del daño excede este valor el cliente pagará el excedente. No cubre robos parciales ni daños en el interior del vehículo.<br/>
          Incluye Protección Individual por accidente a los pasajeros del vehículo de Budget. Reembolso de gastos médicos hasta por un monto de US5, 000 por el total de pasajeros del vehículo, siempre que no excedan la capacidad de éste.<br/>
          </p>
          </li>
          <li>
          <h2>Full Cover (CDW + CLP + SLI + CDP + PIA + CAC + ACD)</h2>
          <h3>US$44.99 diarios</h3>
          <p>
          Exime totalmente en caso de daños por colisión y 80% en caso de robo total del vehículo.<br/>
          Cobertura de Responsabilidad Civil a terceros. Cobertura máxima: US$15,000. Deducible: 20%.<br/>
          Cubre daños a llantas y daños en todos los vidrios del vehículo.<br/>
          Adicionalmente, esta cobertura protege al cliente en caso de rayones, raspaduras, abolladuras, daños a: llavines, antenas, manecillas, espejos laterales, stops y otros daños a la carrocería del vehículo. Cubre robos parciales y daños en el interior del vehículo.<br/>
          Por esta cobertura la empresa asumirá un máximo de US$500.00. Si el monto del daño excede este valor el cliente pagará el excedente.<br/>
          Incluye Protección Individual por accidente a los pasajeros del vehículo de Budget. Reembolso de gastos médicos hasta por un monto de US5,000 por el total de pasajeros del vehículo, siempre que no excedan la capacidad de éste.<br/>
          Cobertura de Asistencia en Carretera en caso de dificultado o emergencia las 24 horas.<br/>
          </p>
          </li>
          <li>
          <h2>Cobertura PIA</h2>
          <h3>US$3.99 diarios</h3>
          <p>
          Protección Individual por accidente a los pasajeros del vehículo de Budget.<br/>
          Reembolso de gastos médicos hasta por un monto de US5,000, independientemente del número de pasajeros del vehículo que no excedan la capacidad de éste.<br/>
          Se activa fuera del país si toma la C4.<br/>
          </p>
          </li>
          <li>
          <h2>Cobertura CLP</h2>
          <h3>US$5.00 diarios</h3>
          <p>
          Esta cobertura libera la responsabilidad del cliente en caso de daños a las llantas y/o a todos los vidrios del vehículo de Budget. No cubre robo.<br/>
          </p>
          </li>

          <li>
          <h2>Cobertura CAC</h2>
          <h3>US$3.50 diarios</h3>
          <p>
          Cobertura de Asistencia de Carreteras. Se le dará asistencia en caso de una dificultad o emergencia inesperada las 24 horas.<br/>

          Requisitos:<br/>
          Estas coberturas no protegen en los casos que resultasen cuando:<br/>

          <li>El uso del vehículo rentado viole las restricciones específicas del contrato de renta</li>
          <li>El conductor esté bajo influencia de alcohol o drogas, o en actos ilícitos.</li>
          <li>El conductor es menor de 25 años</li>
          <li>La licencia de conducir no esta vigente</li>
          <li>No se presenta certificado de policía</li>
          <li>El conductor no está registrado en el contrato</li>
          </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
)
export default ProtectionsCoveragesEn*/



import React, { Component } from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'


class ProtectionsCoveragesEs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      descriptionEs: '',
    }

    this.renderTextsCoverage = this.renderTextsCoverage.bind(this)

    
  }
  componentDidMount() {


      axios
      .get(`${backendURL}/api/texts/sections/TextCovertura/Main`)  
      .then(res => {

        const txt = res.data;

        console.log(txt);

        this.setState({     
          descriptionEs:{
            es: txt.descriptionEs,
          }, 
        })
        })

     

      .catch(err => {
        console.log(err)
      })
  }


  renderTextsCoverage() {
    const { texts } = this.state
    return _.map(texts, (text, i) => {
      const { descriptionEs , published } = text
      //const { langKey: lang } = this.props.pathContext
      console.log(text);
      if (published) {
        return (
          <div key={i}>
          <p> 
            {descriptionEs.es} 
          </p>
          </div>
        )
        return null
      }
    })
  } 


  render() {
    return (
      <div className="page corporate_program">
      <Helmet
         title={`Corporate Program |  Budget Guatemala`}
         meta={[
           {
             name: 'description',
             content:
               'Frequently Asked Questions about car rentals.',
           },
         ]}
         link={[
           {
             rel: 'alternate',
             hreflang: 'en',
             href:
               './es/corporate_program',
           },
         ]}
       />
       <div className="image"></div>
       <h1>Protecciones y Coberturas</h1>
    <div dangerouslySetInnerHTML={{__html: this.state.descriptionEs.es}}></div>
</div>
    )
  }
}

export default ProtectionsCoveragesEs


// WEBPACK FOOTER //
// ./src/pages/protections-coverages.es.js